import React, { useLayoutEffect, useRef, useState } from 'react'

import { Icon, Close, Button, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string, bool, func } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

const TOP_CLEARANCE = 96

function PaymentAgreementBlocker({
  paymentAgreementBlocker,
  onClose,
}) {
  const popoverRef = useRef(null)
  const [placement, setPlacement] = useState('top')

  useLayoutEffect(() => {
    const node = popoverRef.current

    if (!node || !node.parentElement) return

    const spaceAbove = node.parentElement.getBoundingClientRect().top

    if (spaceAbove < node.offsetHeight + TOP_CLEARANCE) {
      setPlacement('below')
    }
  }, [])

  const { message, ctaLabel, dismissLabel, ctaHref, showCta } = paymentAgreementBlocker
  const fallbackMessage = i18n.t('rails:publisher.payment_agreement_blocker.message')
  const fallbackCta = i18n.t('rails:publisher.payment_agreement_blocker.cta')
  const fallbackDismiss = i18n.t('rails:publisher.payment_agreement_blocker.dismiss')

  const displayMessage = message || fallbackMessage
  const displayCtaLabel = ctaLabel || fallbackCta
  const displayDismissLabel = dismissLabel || fallbackDismiss
  const displayCtaHref = ctaHref || '/profile/hyperwallet-account'

  return (
    <div
      ref={popoverRef}
      className={classnames(
        'publishing-actions__popover',
        'publishing-actions__popover--new',
        placement === 'below' && 'publishing-actions__popover--below',
      )}
    >
      <Icon
        className="publishing-actions__popover-close"
        color="dark"
        notSpaced
        size="default"
        type="AIDisabled"
        withHover
        onClick={onClose}
        svgComponent={Close}
      />
      <p
        className="publishing-actions__popover-message"
        dangerouslySetInnerHTML={{ __html: displayMessage }}
      />
      <div className="publishing-actions__popover-actions">
        {showCta && (
          <Button
            type="primary"
            href={displayCtaHref}
            linkAttributes={{
              target: '_blank',
              rel: 'noopener noreferrer',
            }}
          >
            {displayCtaLabel}
          </Button>
        )}
        <Button
          type="secondary"
          onClick={onClose}
        >
          {displayDismissLabel}
        </Button>
      </div>
    </div>
  )
}

PaymentAgreementBlocker.propTypes = {
  paymentAgreementBlocker: shape({
    message: string,
    ctaLabel: string,
    dismissLabel: string,
    ctaHref: string,
    showCta: bool,
  }).isRequired,
  onClose: func.isRequired,
}

export default PaymentAgreementBlocker
